/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginStoreResponse } from '../../models/login-store-response';

export interface PostLogin$Params {
      body: any
}

export function postLogin(http: HttpClient, rootUrl: string, params: PostLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStoreResponse>> {
  const rb = new RequestBuilder(rootUrl, postLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginStoreResponse>;
    })
  );
}

postLogin.PATH = '/v1/login';
